import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c1b344a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/chatbox.css?vue&type=style&index=0&id=7c1b344a&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/sp/chatbox.css?vue&type=style&index=1&id=7c1b344a&prod&scoped=true&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&id=7c1b344a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b344a",
  null
  
)

export default component.exports